export const Cookie = {
  jwt: "jwt",
  jwtSigned: "jwtSigned",
};
